import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import TicketMobile from './TicketMobile';
import EmptyState from '../emptyState/EmptyState';
import ErrorState from '../../../common/errorState/errorState';
import { ticketListMessages } from '../../../../constants/Messages';
import { getTicketImage } from '../../../../redux/actions/TicketActions';

const TicketContainerMobile = ({ ...props }) => {
  const { tickets, ticketStatus } = props;
  const dispatch = useDispatch();

  const ticketsList = (sku, innerTickets) => {
    if (!sku) return innerTickets;
    return tickets.filter((ticket) => ticket.sku === sku);
  };

  useEffect(() => {
    tickets.forEach((ticket) => {
      if (!('thumbnailImage' in ticket) && ticketStatus === 'succeded')
        dispatch(getTicketImage(ticket.sku));
    });
  }, [tickets]);

  return (
    <Box>
      {ticketStatus === 'succeded' &&
        tickets.map((ticket, index) => (
          <TicketMobile
            key={index}
            tickets={ticket?.sku ? ticketsList(ticket.sku, tickets) : [ticket]}
            ticket={ticket}
          />
        ))}
      {ticketStatus === 'notFound' && <EmptyState mobile />}
      {ticketStatus === 'error' && (
        <ErrorState mobile={true} title={ticketListMessages.error} />
      )}
    </Box>
  );
};

TicketContainerMobile.propTypes = {
  tickets: PropTypes.array,
  ticketStatus: PropTypes.string,
};

export default TicketContainerMobile;
